import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../store/Tasks/actions";
import TaskColumn from "../../components/TaskColumn";
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import "./style.scss";
import TaskForm from "../../components/TaskForm/TaskForm";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";

const Tasks = ({ intl: { messages } }) => {
  const dispatch = useDispatch();
  const lang = localStorage.getItem("lang") || "en";
  const { newTasks, inprogressTasks, completedTasks } = useSelector((state) => state.tasks);
  const [showForm, setShowForm] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [search, setSearch] = useState("");
  const [params, setParams] = useState({
    page: 0,
    status: 0,
    sort: "",
  });
  const [viewMode, setViewMode] = useState(false);
  const [data, setData] = useState({
    newTasks: [],
    inprogressTasks: [],
    completedTasks: [],
  });

  // Get && Sort Data Hook
  useEffect(() => {
    dispatch(actions.newTasksRequest({sort:'complete_date,asc',status: 1 }));
    dispatch(actions.inprogressTasksRequest({sort:'updated_at,desc', status: 2 }));
    dispatch(actions.completedTasksRequest({ sort:'complete_date,desc',status: 4 }));
    return () => {
      dispatch(actions.newTasksReceive([]));
      dispatch(actions.inprogressTasksReceive([]));
      dispatch(actions.completedTasksReceive([]));
    };
  }, [dispatch]);

  // Get Tasks by page

  useEffect(() => {
    if (params) {
      if (params.status === 1) {
        dispatch(actions.newTasksRequest(params));
      } else if ( params.status === 2 || params.status === 3) {
        dispatch(actions.inprogressTasksRequest(params));
      } else if ( params.status === 4 || params.status === 5) {
        dispatch(actions.completedTasksRequest(params));
      } 
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  // Set default data hook
  useEffect(() => {
    if (newTasks && inprogressTasks && completedTasks) {
      setData({
        newTasks: newTasks.data?.sort((a, b) => {
          const dateA = new Date(a.complete_date);
          const dateB = new Date(b.complete_date);
          return dateA - dateB;
        }),
        inprogressTasks: inprogressTasks.data,
        completedTasks: completedTasks.data,
      });
    }
  }, [newTasks, inprogressTasks, completedTasks]);

  
  // Search Hook
  useEffect(() => {
    if (newTasks.data?.length > 0 && inprogressTasks.data?.length > 0 && completedTasks.data?.length > 0) {
      if (search.length > 0) {
        setData({
          newTasks: newTasks.data.filter((task) => task.description.search(search) > -1),
          inprogressTasks: inprogressTasks.data.filter((task) => task.description.search(search) > -1),
          completedTasks: completedTasks.data.filter((task) => task.description.search(search) > -1),
        });
      } else {
        setData({
          newTasks: newTasks.data?.sort((a, b) => {
            const dateA = new Date(a.complete_date);
            const dateB = new Date(b.complete_date);
            return dateA - dateB;
          }),
          inprogressTasks: inprogressTasks.data,
          completedTasks: completedTasks.data,
        });
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  // Delete Task
  const deleteTask = () => {
    dispatch(actions.deleteTaskRequest(selectedTask.id));
    setDeleteConfirmation(false);
  }

  // Active View mode
  const activeViewMode = (task) => {
    setViewMode(true);
    setSelectedTask(task);
    setShowForm(true);
  }

  return (
    <section className="tasks-container">
      <div className="tasks-container_header">
        <button className={`tasks-container_header_btn ${lang === 'ar' && 'rtl'}`} 
                onClick={(e) => {e.preventDefault(); setViewMode(false); setSelectedTask(null); setShowForm(true)}}>
          <AddCircleOutlineOutlinedIcon />{messages.tasks.add_new_task}
        </button>
        <div className={`tasks-container_header_search  ${lang === 'ar' && 'rtl'}`}>
          <input type="text" placeholder={messages.tasks.search_content} 
                 value={search} onChange={(e) => setSearch(e.target.value)}/>
          <SearchOutlinedIcon />
        </div>
      </div>
      <div className="row">
        <TaskColumn className="col-md-4"
          status_id={1}
          type='new'
          title={
            <>
              <h6 className="mb-3" style={{ color: '#4564f9' }}>
                {messages.tasks.new_tasks}
                <span  className="mx-3 text-dark">({newTasks?.pagination?.total})</span>
              </h6>
            </>
          }
          data={data?.newTasks}
          pagination={newTasks?.pagination}
          handleSelectTask={(task) => {setViewMode(false); setSelectedTask(task); setShowForm(true)}}
          handleDeleteTask={(task) => {setSelectedTask(task); setDeleteConfirmation(true)}}
          handleActiveViewMode={(task) => activeViewMode(task)}
          handleGetTasks={(page, status_id) => setParams({ page: page, status: status_id, sort: status_id === 2 ? 'updated_at,desc' : 'complete_date,asc' })}
        />
        <TaskColumn className="col-md-4"
          status_id={2}
          type='inprogress'
          title={
            <>
              <h6 className='mb-3' style={{ color: '#67dcfe' }}>
                {messages.tasks.inprogress_tasks}
                <span  className="mx-3 text-dark">({inprogressTasks?.pagination?.total})</span>
              </h6>
            </>
          }
          data={data?.inprogressTasks}
          pagination={inprogressTasks?.pagination}
          handleSelectTask={(task) => {setViewMode(false); setSelectedTask(task); setShowForm(true)}}
          handleActiveViewMode={(task) => activeViewMode(task)}
          handleGetTasks={(page, status_id) => setParams({ page: page, status: status_id, sort: status_id === 2 ? 'updated_at,desc' : 'complete_date,asc' })}
        />
        <TaskColumn className="col-md-4"
          status_id={4}
          type='complete'
          title={
            <>
              <h6 className='mb-3' style={{ color: '#24d7d3' }}>
                {messages.tasks.completed_tasks}
                <span className="mx-3 text-dark">({completedTasks?.pagination?.total})</span>
              </h6>
            </>
          }
          data={data?.completedTasks}
          pagination={completedTasks?.pagination}
          handleActiveViewMode={(task) => activeViewMode(task)}
          handleGetTasks={(page, status_id) => setParams({ page: page, status: status_id, sort: status_id === 2 ? 'updated_at,desc' : 'complete_date,asc' })}
        />
      </div>
      <TaskForm show={showForm} close={() => setShowForm(false)} task={selectedTask} view={viewMode} />
      <ConfirmDialog show={deleteConfirmation} 
                     onCancel={() => setDeleteConfirmation(false)}
                     onConfirm={() => deleteTask()}
                     content={messages.warningMsgs.warning_delete}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
    </section>
  )
}

export default injectIntl(Tasks);
